<section class="why-book-us box-sec section" [id]="child">
  <div class="container">
    <div class="sec-head">
      <h2>Why Book with Us! </h2>
    </div>
    <div class="cat-box-wrap d-flex justify-content-between flex-wrap">
      <div class="cat-outer-box">
        <div class="packages-details">
          <span class="box-icon"> <img src="assets/images/expertise.png" alt="Expertise" /></span>
          <h3> Expertise </h3>
          <div class="scrollBox">
            <p> Our platform provides end-to-end solution for searching, comparing and booking wellness experiences. Simple, intuitive, and streamlined process that ensures a great experience.   </p>
          </div>
        </div>
      </div>
      <div class="cat-outer-box">
        <div class="packages-details">
          <span class="box-icon"> <img src="assets/images/service.png" alt="Service & Value" /></span>
          <h3> Service & Value</h3>
          <div class="scrollBox">
            <p> We only approve the packages qualifying the industry standards
              to be on our platform, so you can
              be assured that your wellness destination is one of a kind. </p>
          </div>
        </div>
      </div>
      <div class="cat-outer-box">
        <div class="packages-details">
          <span class="box-icon"> <img src="assets/images/secured.png" alt="Best Price Guarantee" /></span>
          <h3> Best Price Guarantee </h3>
          <div class="scrollBox">
            <p> No need to shop around. Our partners are required to list their packages at the lowest prices so you don't have to think twice. If you find a lower price, we refund the difference. </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
